// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"559eca2e","300":"18f2d60a","493":"d6ad88f2","964":"47c40b92"}[chunkId] + ".792362f3a261.chunk.css";
};